<template>
    <v-container>
      <v-row>
          <v-col cols="12">
            <div class="text-left" style="margin-bottom:20px;">
                <router-link to="/archive">
                    <v-btn
                        color="secondary"
                        class="text-right"
                        style="width:250px"
                    >
                        Back
                    </v-btn>
                </router-link>
              </div>                  
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h1>Las Vegas</h1>
        </v-col>
      </v-row>
      


      <h2 class="text-left">Extended 82nd Birthday Trip</h2>
      <div class="text-left">8th September - Extended Birthday</div>
      <div class="text-left">20 hours travelling!</div>
      <div class="text-left">Super Bingo Registration</div>
      <v-row style="margin-top:10px;">
        <v-col cols="12" class="text-left">
          <a href="https://www.plazahotelcasino.com/bingo/super-bingo/" target="_blank">

              <v-btn
                color="primary"
                class="text-right"
                style="width:500px; margin-top:5px;margin-bottom:15px;"
              >
                $160,000 Super Bingo
              </v-btn>
          </a>
        </v-col>
      </v-row>
      <v-row style="margin-top:10px;">
        <v-col class="text-left" cols="12">Dinner</v-col>
        <v-col cols="12" class="text-left">
          <a href="https://www.eiffeltowerrestaurant.com/" target="_blank">

              <v-btn
                color="primary"
                class="text-right"
                style="width:500px; margin-top:-20px;margin-bottom:15px;"
              >
                Eiffel Tower Restaurant
              </v-btn>
          </a>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-left" cols="12">Desert</v-col>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:20px;">
            <a href="https://www.caesars.com/paris-las-vegas/restaurants/vanderpump-a-paris" target="_blank">
              <v-btn
                color="primary"
                class="text-right"
                style="width:500px; margin-top:-20px;"
              >
                Vanderpump à Paris
              </v-btn>
            </a>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:20px;">
            <h2>Birthday Trip Day 2</h2>
            <div class="text-left">9th September</div>
            <div class="text-left">Super Bingo Day 1</div>
            <v-row style="margin-top:0px;">
              <v-col cols="12" class="text-left">
                <a href="https://www.plazahotelcasino.com/bingo/super-bingo/" target="_blank">

                    <v-btn
                      color="primary"
                      class="text-right"
                      style="width:500px; margin-top:5px;margin-bottom:0px;"
                    >
                      $160,000 Super Bingo
                    </v-btn>
                </a>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-left">
                <a href="https://www.caesars.com/caesars-palace/restaurants/bacchanal-buffet" target="_blank">

                    <v-btn
                      color="primary"
                      class="text-right"
                      style="width:500px; margin-top:15px;margin-bottom:15px;"
                    >
                      Buffet
                    </v-btn>
                </a>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:20px;">
            <h2>Birthday Trip Day 3</h2>
            <div class="text-left">10th September</div>
            <div class="text-left">Super Bingo Day 2</div>
            <a href="https://www.plazahotelcasino.com/bingo/super-bingo/" target="_blank">

                <v-btn
                  color="primary"
                  class="text-right"
                  style="width:500px; margin-top:5px;margin-bottom:0px;"
                >
                  $160,000 Super Bingo
                </v-btn>
            </a>
          </div>
        </v-col>
      </v-row>
      <v-row style="margin-top:10px;">
        <v-col cols="12" class="text-left">
          <a href="https://www.thesphere.com/shows/wizard-of-oz-experience" target="_blank">

              <v-btn
                color="primary"
                class="text-right"
                style="width:500px; margin-bottom:15px;"
              >
                Sphere - Wizard of Oz
              </v-btn>
          </a>
        </v-col>
        <v-col cols="12">
          <video autoplay="" loop="" playsinline="" poster="" disableremoteplayback=""><source src="https://us-east-1-msg.graphassets.com/ALB6wy2xYSoCFY4hrWCvsz/cmc4wqght0njr07lnczs5q1hf" type="video/mp4"></video>            
        </v-col>
      </v-row>      
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:20px;">
            <h2>Birthday Trip Day 4</h2>
            <div class="text-left">11th September</div>
            <a href="https://www.flyoverlasvegas.com/" target="_blank">

                <v-btn
                  color="primary"
                  class="text-right"
                  style="width:500px; margin-top:5px;margin-bottom:15px;"
                >
                  Flyover?
                </v-btn>
            </a>
          </div>
          <div class="text-left">Airport 6:15PM</div>
        </v-col>
      </v-row>      
      <div style="margin-top:30px;"></div>
      <div></div>
      <div class="text-left">8th 10:20am Sydney to San Francisco Arrive UA870 6:55am</div>
      <div class="text-left">8th 10:40am San Francisco to Las Vegas Arrive UA611 12:24pm</div>
      <div class="text-left">8th 12:24pm UA    Planet Hollywood  CONF# 42012</div>
      <div style="background-color: gray;color:white">            Hell's Kitchen 1pm</div>
      <div class="text-left">8th  3:00pm Caesar's to  Plaza Hotel CONF# 42013</div>
      <div class="text-left">8th  4:30pm Plaza Hotel to Paris CONF# 42014</div>
      <div style="background-color: gray;color:white">            Eiffel Tower Restaurant 5pm</div>
      <div style="background-color: gray;color:white">            Vanderpump Paris 6pm</div>
      <div class="text-left">10th 4:00PM PLAZA TO SPHERE CONF# 0042060</div>
      <div style="background-color: gray;color:white">            Wizard of Oz 5pm start</div>
      <div class="text-left">10th 6:45PM SPHERE TO PLAZA-PHV CONF# 0042061</div>
      <div class="text-left">11th 11:00AM PLAZA TO PHV CONF# 0042062</div>
      <div style="background-color: gray;color:white">            Caesars Buffet 12pm</div>
      <div class="text-left">11th 4:15PM PHV TO AIRPORT CONF# 0042063</div>
      <div class="text-left">11th 6:49pm Las Vegas to Los Angeles Arrive UA2282 8:07pm</div>
      <div class="text-left">11th 10:45pm Los Angeles to Sydney Arrive UA839 7:00am</div>    

      
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {

    }
  }
  </script>